<template>
    <div>
      <b-modal
    id="single-module-modal"
    :visible="true"
    @hide="$emit('close')"
    hide-footer
    title="Module Details"
  >
        <!-- Evaluation Module -->
        <div v-if="module.module_type === 'evaluation'" class="mt-1 ml-2">
          <div><strong>Subjects:</strong>
            <template v-if="module.subjects_data && module.subjects_data.length">
              <span v-for="(subject, index) in module.subjects_data" :key="index">
                {{ subject.subjectName || 'N/A' }}<span v-if="index !== module.subjects_data.length - 1">, </span>
              </span>
            </template>
            <template v-else>N/A</template>
          </div>
          <div><strong>Topics:</strong>
            <template v-if="module.topics_data && module.topics_data.length">
                <div v-for="(topic, index) in module.topics_data" :key="'topic_' + index">
                {{ index + 1 }}. {{ topic.categoryName || 'N/A' }}
                </div>
            </template>

            <template v-else-if="module.topicId && module.topicId.length">
                <div v-for="(topic, index) in module.topicId" :key="'topicId_' + index">
                {{ index + 1 }}. {{ topic.categoryName || 'N/A' }}
                </div>
            </template>

            <template v-else>
                <div>N/A</div>
            </template>
          </div>


          <!-- <div><strong>Topics:</strong>
            <template v-if="module.topics_data && module.topics_data.length">
              <span v-for="(topic, index) in module.topics_data" :key="'topic_' + index">
                {{ topic.categoryName || 'N/A' }}<span v-if="index !== module.topics_data.length - 1">, </span>
              </span>
            </template>
            <template v-else-if="module.topicId && module.topicId.length">
              <span v-for="(topic, index) in module.topicId" :key="'topicId_' + index">
                {{ topic.categoryName || 'N/A' }}<span v-if="index !== module.topicId.length - 1">, </span>
              </span>
            </template>
            <template v-else>N/A</template>
          </div> -->
  
          <div><strong>Estimated Time:</strong> {{ module.estimated_time || 'N/A' }}</div>
          <div><strong>Total Questions:</strong> {{ module.total_question || 'N/A' }}</div>
        </div>


        <!-- comprehensive -->
        <div v-if="module.module_type === 'comprehensive'" class="mt-1 ml-2">
          <div><strong>Subjects:</strong>
            <template v-if="module.subjects_data && module.subjects_data.length">
              <span v-for="(subject, index) in module.subjects_data" :key="index">
                {{ subject.subjectName || 'N/A' }}<span v-if="index !== module.subjects_data.length - 1">, </span>
              </span>
            </template>
            <template v-else>N/A</template>
          </div>
          <div><strong>Topics:</strong>
            <template v-if="module.topics_data && module.topics_data.length">
                <div v-for="(topic, index) in module.topics_data" :key="'topic_' + index">
                {{ index + 1 }}. {{ topic.categoryName || 'N/A' }}
                </div>
            </template>

            <template v-else-if="module.topicId && module.topicId.length">
                <div v-for="(topic, index) in module.topicId" :key="'topicId_' + index">
                {{ index + 1 }}. {{ topic.categoryName || 'N/A' }}
                </div>
            </template>

            <template v-else>
                <div>N/A</div>
            </template>
          </div>
          <div><strong>Weightages:</strong>
  <template v-if="module.weightages && module.weightages.length">
    <span v-for="(w, index) in module.weightages" :key="'w_' + index">
      {{ w.subject_weightages.subjectName || 'N/A' }} 
      ({{ w.percentage || '0' }}%, {{ w.mcqs || '0' }} mcqs)
      <span v-if="index !== module.weightages.length - 1">, </span>
    </span>
  </template>
  <template v-else>
    N/A
  </template>
</div>
          <!-- <div><strong>Weightages:</strong> {{ module.weightages || 'N/A' }}</div> -->
          <div><strong>Test Title:</strong> {{ module.title_test || 'N/A' }}</div>
          <div><strong>Total Marks:</strong> {{ module.total_marks || 'N/A' }}</div>
          <div><strong>Estimated Time:</strong> {{ module.estimated_time || 'N/A' }}</div>
          <div><strong>Total Questions:</strong> {{ module.total_question || 'N/A' }}</div>
        </div>
  
        <!-- Topic Module -->
        <div v-else-if="module.module_type === 'topic'" class="mt-1 ml-2">
          <div><strong>Topic:</strong>
            <template v-if="module.topics_data && module.topics_data.length">
              <span v-for="(topic, index) in module.topics_data" :key="'topic_' + index">
                {{ topic.categoryName || 'N/A' }}<span v-if="index !== module.topics_data.length - 1">, </span>
              </span>
            </template>
            <template v-else-if="module.topicId && module.topicId.length">
              <span v-for="(topic, index) in module.topicId" :key="'topicId_' + index">
                {{ topic.categoryName || 'N/A' }}<span v-if="index !== module.topicId.length - 1">, </span>
              </span>
            </template>
            <template v-else>N/A</template>
          </div>
        </div>
  
        <!-- Chapter Module -->
        <div v-else-if="module.module_type === 'chapter'" class="mt-1 ml-2">
          <div><strong>Chapter No:</strong> {{ module.chapter_no || 'N/A' }}</div>
          <div><strong>Description:</strong> {{ module.description || 'N/A' }}</div>
        </div>
  
        <!-- Fallback -->
        <!-- <div v-else class="mt-1 ml-2">
          <p>No module details available.</p>
        </div> -->
      </b-modal>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      module: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        isVisible: true,
      };
    },
    watch: {
      module() {
        this.isVisible = true;
      },
    },
  };
  </script>
  
  <style scoped lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  
  .modal-backdrop {
    opacity: 0.5 !important;
    background-color: #000 !important;
  }
  
  .modal {
    backdrop-filter: none !important;
  }
  </style>